/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";

export interface TradeRowWrapperProps {
  children: React.ReactNode;
}

export const TradeRowWrapper: React.FC<TradeRowWrapperProps> = ({ children }) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        padding: 0;
        width: 100%;
        margin: 0 auto;
        justify-content: space-between;
      `}
    >
      {children}
    </div>
  );
};
